module.exports = "/_next/static/images/video_id_7172318367292853547-1cc6a5650f717668aaf4b804ed15b40d.jpg";